import React from 'react'
import { Block, ImageWithContent } from '@components'

const DatoCmsImageWithContent = ({ paddingTop, paddingBottom, ...props }) => {
  return (
    <Block paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <ImageWithContent {...props} />
    </Block>
  )
}

export default DatoCmsImageWithContent
